import React, {useState, useEffect} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {Form, Field} from 'react-final-form';
import {Panel} from "primereact/panel";
import {Button} from 'primereact/button';
import {Dropdown} from "primereact/dropdown";
import {Calendar} from "primereact/calendar";
import {InputText} from "primereact/inputtext";
import {InputSwitch} from "primereact/inputswitch";
import {SplitButton} from "primereact/splitbutton";
import {withTranslation} from 'react-i18next';
import {classNames} from 'primereact/utils';
import {addLocale} from "primereact/api";
import moment from "moment";
import axios from "axios";
import Cookies from "js-cookie";

import HelpComponent from "../HelpComponent";
import _FM_ReservationErrorsListComponent from "./_FM_ReservationErrorsListComponent";

const _FM_ReservationResourceFormComponent = (props) => {

  const {t} = props;
  const navigate = useNavigate();
  const {id, action} = useParams();
  const [formData, setFormData] = useState({});
  const [dailyReservationAllowed, setDailyReservationAllowed] = useState(false);
  const [dailyReservationOnly, setDailyReservationOnly] = useState(false);
  const [reservationFromToInputType, setReservationFromToInputType] = useState('merged');
  const [reservedFromDate, setReservedFromDate] = useState('');
  const [reservedFromTime, setReservedFromTime] = useState('15:00');
  const [reservedToDate, setReservedToDate] = useState('');
  const [reservedToTime, setReservedToTime] = useState('10:00');
  const [relocated, setRelocated] = useState(false);
  const [unit, setUnit] = useState([]);
  const [berth, setBerth] = useState([]);
  const [chanel, setChanel] = useState([]);
  const [priceCategories, setPriceCategories] = useState([]);
  const [possibleStatuses, setPossibleStatuses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [guestInfos, setGuestInfos] = useState([]);

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
  }

  const validate = (data) => {
    let errors = {};
    if (!data.residential_unit) {
      errors.residential_unit = t('required_field');
    }
    // if (!data.reserved_from) {
    //   errors.reserved_from = t('required_field');
    // }
    const hasContactEmail = !!(data.contact_email && String(data.contact_email).trim());
    const hasContactNumber = !!(data.contact_number && String(data.contact_number).trim());
    if (!hasContactEmail && !hasContactNumber) {
      errors.contact_email = t('required_field');
      errors.contact_number = t('required_field');
    }
    if (!data.contact_name) {
      errors.contact_name = t('required_field');
    }
    if (!data.number_of_guests) {
      errors.number_of_guests = t('required_field');
    }
    if (!data.price_category) {
      errors.price_category = t('required_field');
    }
    if (!data.guest_information_request_page) {
      errors.guest_information_request_page = t('required_field');
    }
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    const _fromDatePart = moment.utc(reservedFromDate).local().format('YYYY-MM-DD');
    const _fromTimePart = reservedFromTime;
    const [_fromHour, _fromMinute] = _fromTimePart.split(":");
    const _fromAdjustedHour = (parseInt(_fromHour, 10) - 1).toString().padStart(2, "0");
    const _fromAdjustedTimePart = `${_fromAdjustedHour}:${_fromMinute}`;
    const _fromCombinedString = `${_fromDatePart}T${_fromAdjustedTimePart}:00Z`;
    const _fromUtcDate = new Date(_fromCombinedString);
    const _toDatePart = moment.utc(reservedToDate).local().format('YYYY-MM-DD');
    const _toTimePart = reservedToTime;
    const [_toHour, _toMinute] = _toTimePart.split(":");
    const _toAdjustedHour = (parseInt(_toHour, 10) - 1).toString().padStart(2, "0");
    const _toAdjustedTimePart = `${_toAdjustedHour}:${_toMinute}`;
    const _toCombinedString = `${_toDatePart}T${_toAdjustedTimePart}:00Z`;
    const _toUtcDate = new Date(_toCombinedString);
    data = {
      ...data,
      reserved_from: _fromUtcDate,
      reserved_to: _toUtcDate
    }
    if (formData.id) {
      apiCall('patch', 'reservation/' + formData.id, data)
        .then(response => {
          setLoading(false)
          window.App.toastShow('success', t('success'), response.data.message)
          window.App.setState({
            rerenderReservationGuestList: Math.random(),
            rerenderReservationList: Math.random(),
            selectedReservationId: response.data.data.id,
          })
          if (props.closeForm === true) {
            navigate(-1)
          }
        })
        .catch(error => {
          setLoading(false)
          window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
        })

    } else {
      apiCall('post', 'reservation', data)
        .then(response => {
          setFormData(response.data.data)
          setLoading(false)
          window.App.toastShow('success', t('success'), response.data.message)
          window.App.setState({
            rerenderReservationGuestList: Math.random(),
            rerenderReservationList: Math.random(),
            selectedReservationId: response.data.data.id,
          })
          if (props.closeForm === true) {
            navigate(-1)
          }
        })
        .catch(error => {
          setLoading(false)
          window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
        })
    }
    form.restart();
  };
  const isFormFieldValid = (meta) => {
    if (loading) return false;
    return !!(meta.error);
  };
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-validate">{meta.error}</small>;
  };
  const DailyReservationAllowed = (unitId) => {
    apiCall('get', 'residential-unit/' + unitId)
      .then(response => {
        if (response.data && response.data.data && response.data.data.residential_category) {
          apiCall('get', "residential-category/" + response.data.data.residential_category.id)
            .then(response => {
              if (response.data && response.data.data && response.data.data.accommodation) {
                apiCall('get', "accommodation/" + response.data.data.accommodation.id)
                  .then(response => {
                    setReservationFromToInputType(response?.data?.data?.reservation_from_to_input_type ?? null)
                    if (response.data && response.data.data && response.data.data.daily_reservation_allowed && response.data.data.daily_reservation_allowed === true) {
                      setDailyReservationAllowed(true)
                    } else {
                      setDailyReservationAllowed(false)
                    }
                  })
                  .catch(error => {
                    window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                  })
              }
            })
            .catch(error => {
              window.App.toastShow('error', t('error'), error.toString(), '', error.response);
            })
        }
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
  }

  addLocale('default', {
    firstDayOfWeek: 1,
    dayNames: [t('sunday'), t('monday'), t('tuesday'), t('wednesday'), t('thursday'), t('friday'), t('saturday')],
    dayNamesShort: [t('sun'), t('mon'), t('tue'), t('wed'), t('thu'), t('fri'), t('sat')],
    dayNamesMin: [t('sun'), t('mon'), t('tue'), t('wed'), t('thu'), t('fri'), t('sat')],
    monthNames: [t('jan'), t('feb'), t('mar'), t('apr'), t('may'), t('jun'), t('jul'), t('aug'), t('sep'),
      t('oct'), t('nov'), t('dec')],
    monthNamesShort: [t('jan'), t('feb'), t('mar'), t('apr'), t('may'), t('jun'), t('jul'), t('aug'), t('sep'),
      t('oct'), t('nov'), t('dec')],
    today: t('today'),
    clear: t('delete')
  });

  useEffect(() => {
    if (formData && formData.residential_unit && formData.residential_unit.id) {
      setFormData({
        ...formData,
        residential_unit: formData.residential_unit.id
      })
    }
    if (formData && formData.residential_unit && !formData.residential_unit.id) {
      apiCall('get', 'berth' + '?search[residential_unit][operator]==&search[residential_unit][value]=' + formData.residential_unit)
        .then(response => {
          setLoading(false)
          setBerth(response.data.data.items);
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          setLoading(false)
        })
      apiCall('get', 'residential-unit/' + formData?.residential_unit)
        .then(response => {
          apiCall('get', 'price-category?search[accommodation][operator]=%3D&search[accommodation][value]=' + response.data?.data?.accommodation?.id)
            .then(response => {
              if (response.data.data.items) {
                setPriceCategories(response.data.data.items);
              } else {
                window.App.toastShow('warn', t('warning'), t('price_category_reservation_not_allowed'));
              }
            })
            .catch(error => {

            })
        })
    }

  }, [formData.residential_unit])

  useEffect(() => {
    if (formData && formData.berth && formData.berth.id) {
      setFormData({
        ...formData,
        berth: formData.berth.id
      })
    }
    if (formData && formData.berth && formData.berth.residential_unit) {
      setFormData({
        ...formData,
        residential_unit: formData.berth.residential_unit.id,
        berth: formData.berth.id
      })
    }
  }, [formData.berth])

  useEffect(() => {
    if (window.App.state && window.App.state.propsReservation && window.App.state.propsReservation) {
      let formattedFromDate = moment.utc(window.App.state.propsReservation.reserved_from).local().format(t('YYYY-MM-DD'));
      let formattedToDate = moment.utc(window.App.state.propsReservation.reserved_to).local().format(t('YYYY-MM-DD'));
      setReservedFromDate(formattedFromDate)
      setReservedToDate(formattedToDate)
      let _unit = null
      let _bed = null
      if (window.App.state.propsReservation && window.App.state.propsReservation.resource && window.App.state.propsReservation.resource.toString().includes('U-')) {
        _unit = Number(window.App.state.propsReservation.resource.toString().replace('U-', ''))
        DailyReservationAllowed(_unit)
        setFormData({
          ...formData,
          id: window.App.state.propsReservation.id,
          note: window.App.state.propsReservation.note,
          status: window.App.state.propsReservation.status || 'confirmed',
          residential_unit: _unit,
        })
      }
      if (window.App.state.propsReservation && window.App.state.propsReservation.resource && window.App.state.propsReservation.resource.toString().includes('B-')) {
        apiCall('get', 'berth/' + window.App.state.propsReservation.resource.toString().replace('B-', ''))
          .then(response => {
            _bed = Number(window.App.state.propsReservation.resource.toString().replace('B-', ''))
            _unit = response.data.data.residential_unit.id
            DailyReservationAllowed(_unit)
            setFormData({
              ...formData,
              id: window.App.state.propsReservation.id,
              note: window.App.state.propsReservation.note,
              status: window.App.state.propsReservation.status || 'confirmed',
              residential_unit: _unit,
              berth: _bed,
            })
          })
          .catch(error => {
            window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          })
      }
    }
  }, [window.App.state.propsReservation])

  useEffect(() => {
    //separate reservation date and times
    if (window.App.state.propsReservation && window.App.state.propsReservation.date) {
      let dateString = window.App.state.propsReservation.date.toString();
      let date = new Date(dateString);
      let formattedFromDate = moment.utc(date).local().format(t('YYYY-MM-DD'));
      let formattedFromTime = `${String(date.getUTCHours() - 8).padStart(2, '0')}:${String(date.getUTCMinutes()).padStart(2, '0')}`;
      let formattedToDate = moment.utc(date).local().add(1, 'day').format(t('YYYY-MM-DD'));
      setReservedFromDate(formattedFromDate)
      setReservedToDate(formattedToDate)
    }
  }, [window.App.state.propsReservation])


  useEffect(() => {
    let query = ''
    if (localStorage.getItem('selectedAccommodation') && localStorage.getItem('selectedAccommodation') !== 'undefined') {
      query = '?search[accommodation]=' + localStorage.getItem('selectedAccommodation')
      apiCall('get', 'price-category?search[accommodation][operator]=%3D&search[accommodation][value]=' + localStorage.getItem('selectedAccommodation'))
        .then(response => {
          setPriceCategories(response.data.data.items);
        })
        .catch(error => {
          setLoading(false)
        })
    }
    apiCall('get', 'residential-unit' + query)
      .then(response => {
        setUnit((response.data.data.items || []).map((unitItem) => {
          const accommodationName = unitItem?.residential_category?.accommodation?.name;
          return {
            ...unitItem,
            name: accommodationName ? `${unitItem?.name} (${accommodationName})` : unitItem?.name,
          };
        }));
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    apiCall('get', 'reservation-channel')
      .then(response => {
        setLoading(false)
        setChanel(response.data.data.items);
      })
      .catch(error => {
        setLoading(false)
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    apiCall('get', 'guest-information-request-page')
      .then(response => {
        setGuestInfos(response.data.data.items);
      })
      .catch(error => {
        setLoading(false)
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
  }, [window.App.state.rerenderReservationList])

  useEffect(() => {
    if (!unit[0] || formData.residential_unit) return;
    setFormData((prev) => ({
      ...prev,
      residential_unit: unit[0].id
    }));
  }, [unit, formData.residential_unit]);

  useEffect(() => {
    if (!priceCategories[0] || formData.price_category) return;
    setFormData((prev) => ({
      ...prev,
      price_category: priceCategories[0].id
    }));
  }, [priceCategories, formData.price_category]);

  useEffect(() => {
    if (!guestInfos[0] || formData.guest_information_request_page) return;
    setFormData((prev) => ({
      ...prev,
      guest_information_request_page: guestInfos[0].id
    }));
  }, [guestInfos, formData.guest_information_request_page]);

  return (
    <Form onSubmit={onSubmit} initialValues={formData}
          validate={validate} render={({handleSubmit, form}) => (
      <form
        onSubmit={(event) => {
          const submitResult = handleSubmit(event);
          const formState = form.getState();
          if (formState.submitFailed && (formState.hasValidationErrors || formState.invalid)) {
            window.App.toastShow('warn', t('warning'), t('reservation_submit_required_fields_invalid'));
          }
          return submitResult;
        }}
        className=""
      >

        <div className={"p-grid p-mt-3"}>
          <div className={"p-col p-col-align-center"}>
            <h2 className={"p-m-0"}>
              {t('reservation_form')}
            </h2>
          </div>
          <div className={"p-col p-text-right p-col-align-center"} style={{maxWidth: '60px'}}>
            <Button type="button"
                    icon={"pi pi-times"}
                    onClick={() => {
                      navigate(-1)
                    }}
                    className="p-button-secondary close p-ml-2">
            </Button>
          </div>
        </div>
        <div className={"p-grid"} style={{clear: 'both'}}>
          <div className={"p-col"}>
            <small className={"p-text-uppercase"}>
              {t('reservation_number')}
            </small>
            <p className={"p-mt-0 p-mb-0 p-text-bold"}>
              {t('no_id_yet')}
            </p>
          </div>
          <div className={"p-col"}>
            <small className={"p-text-uppercase"}>
              {t('created_at')}
            </small>
            <p className={"p-mt-0 p-mb-0 p-text-bold"}>
              {moment.utc(formData.created_at_snapshot).local().format(t('YYYY-MM-DD HH:mm:ss'))}
            </p>
          </div>
          <div className={"p-col"}>
            <small className={"p-text-uppercase"}>
              {t('updated_at')}
            </small>
            <p className={"p-mt-0 p-mb-0 p-text-bold"}>
              {moment.utc(formData.updated_at_snapshot).local().format(t('YYYY-MM-DD HH:mm:ss'))}
            </p>
          </div>
          {formData.relocated_to &&
            <div className={"p-col p-col-align-center"}>
                          <span className={"p-badge p-badge-warning p-ml-2"}>{t('relocated_to')}<i
                            className="pi pi-sign-in p-ml-1" style={{fontSize: "0.6rem"}}></i></span>
            </div>
          }
          {formData.relocated_from &&
            <div className={"p-col p-col-align-center"}>
            <span className={"p-badge p-badge-warning p-ml-2"}>
              <i className="pi pi-sign-out p-mr-1" style={{fontSize: "0.6rem"}}></i>
              {t('relocated_from')}
            </span>
            </div>
          }
        </div>
        <Panel className={"p-mt-3"}>
          <div className={"p-grid"}>
            <div className={"p-col p-col-align-center"}>
              <h2 className={"p-m-0 p-d-inline"}>
                {t('reservation_base_data')}
              </h2>
            </div>
            <div className={"p-col p-text-right p-col-align-center"}>
              <Button type="submit" aria-label={t('save')} icon={"pi pi-save"}
                      loading={loading}
                      onClick={() => {
                        props = {...props, closeForm: false}
                      }}
                      className="p-button-success p-ml-2"/>
              {formData.id &&
                <Button type="submit" aria-label={t('save_and_close')}
                        loading={loading}
                        onClick={() => {
                          props = {...props, closeForm: true}
                        }}
                        className="p-button-success p-ml-2">
                      <span>
                        <i className={"pi pi-save"}></i>&nbsp;&nbsp;<i className={"pi pi-backward"}></i>
                      </span>
                </Button>
              }
            </div>
          </div>
          <HelpComponent type={"edit_box"}/>
          <HelpComponent type={"section"} tabNumber={0} sectionNumber={1}/>
          <div className={"p-grid"}>
            <div className={"p-col"}>
              <Field name="residential_unit" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <HelpComponent type={"field"} field={"residential_unit"}/>
                  <label htmlFor="residential_unit"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{t('residential_unit')}</label>
                  <span className="">
                      <Dropdown options={unit}
                                optionLabel="name"
                                optionValue="id"
                                filter
                                id={"residential_unit"}
                                emptyMessage={t('empty_message')}
                                onChange={(e) => {
                                  if (e.value !== formData.residential_unit) {
                                    setRelocated(true)
                                  }
                                  setFormData({
                                    ...formData,
                                    residential_unit: e.value
                                  })
                                  DailyReservationAllowed(e.value)
                                }}
                                value={formData.residential_unit}
                                showClear
                                disabled
                      />
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            {formData.residential_unit && berth && berth[0] && window.App.state.propsReservation.resource.includes('B-') &&
              <div className={"p-col-12 p-lg-4 p-xl-4"}>
                <Field name="berth" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <HelpComponent type={"field"} field={"berth"}/>
                    <label htmlFor="berth"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>{t('berth')}</label>
                    <span className="">
                    {formData.residential_unit && berth && berth[0] ? (
                      <Dropdown options={berth}
                                optionLabel="name"
                                optionValue="id"
                                filter
                                id={"berth"}
                                emptyMessage={t('empty_message')}
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    berth: e.value
                                  })
                                }}
                                value={formData.berth}
                                showClear
                                disabled
                      />
                    ) : (
                      <Dropdown disabled/>
                    )}
                    </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
            }
            <div className={"p-col-12 p-lg-4"}>
              <Field name="daily_reservation_only" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <HelpComponent type={"field"} field={"daily_reservation_only"}/>
                  <label htmlFor="daily_reservation_only"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{t('daily_reservation_only')}</label>
                  <span className="p-d-block">
                    {dailyReservationAllowed === true ? (
                      <InputSwitch
                        className={"p-mt-2"}
                        name={"daily_reservation_only"}
                        value={dailyReservationOnly}
                        checked={dailyReservationOnly}
                        onChange={(e) => {
                          setDailyReservationOnly(e.value)
                          setReservedToDate(reservedFromDate)
                          setReservedFromTime('10:00')
                          setReservedToTime('11:00')
                        }}
                      />
                    ) : (
                      <span onClick={() => {
                        window.App.customToastShow('warn', t('warning'), t('daily_reservation_not_allowed_by_accommodation'));
                      }}>
                          <InputSwitch
                            className={"p-mt-2"}
                            disabled
                          />
                      </span>
                    )}
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
          </div>
          <div className={"p-grid"}>
            <div className={"p-col-12"} style={{minWidth: '160px'}}>
              <Field name="reserved_from" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <HelpComponent type={"field"} field={"reserved_from"}/>
                  <label htmlFor="reserved_from"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{t('reserved_from')} - {t('reserved_to')}</label>
                  <span className="">
                    {formData.residential_unit ? (
                      <>
                        {dailyReservationOnly === true ? (
                          <>
                            <div className={"p-inputgroup"}>
                              <Calendar
                                value={reservedFromDate ? moment(reservedFromDate, 'YYYY-MM-DD').toDate() : null}
                                dateFormat={t('YY-MM-DD')}
                                placeholder={reservedFromDate}
                                locale="default"
                                showOtherMonths
                                selectOtherMonths
                                id={"reserved_from"}
                                onChange={(e) => {
                                  const nextReservedFromDate = e.value ? moment.utc(e.value).local().format(t('YYYY-MM-DD')) : null;
                                  setReservedFromDate(nextReservedFromDate)
                                  setFormData((prevState) => ({
                                    ...prevState,
                                    reserved_from: nextReservedFromDate
                                  }))
                                  input.onChange(nextReservedFromDate)
                                }}/>
                              <Calendar value={reservedFromTime ? moment(reservedFromTime, 'HH:mm').toDate() : null}
                                        dateFormat={t('YY-MM-DD')}
                                        placeholder={reservedFromTime}
                                        locale="default"
                                        id={"reserved_from_time"}
                                        showIcon
                                        showTime={dailyReservationOnly}
                                        timeOnly={dailyReservationOnly}
                                        hourFormat="24"
                                        stepMinute={30}
                                        onChange={(e) => {
                                          setReservedFromTime(moment.utc(e.value).local().format('HH:mm'))
                                        }}/>
                              <Calendar value={reservedToDate ? moment(reservedToDate, 'YYYY-MM-DD').toDate() : null}
                                        dateFormat={t('YY-MM-DD')}
                                        placeholder={reservedToDate}
                                        locale="default"
                                        showOtherMonths
                                        selectOtherMonths
                                        id={"reserved_to"}
                                        onChange={(e) => {
                                          setReservedToDate(moment.utc(e.value).local().format(t('YYYY-MM-DD')))
                                        }}/>
                              <Calendar value={reservedToTime ? moment(reservedToTime, 'HH:mm').toDate() : null}
                                        placeholder={reservedToTime}
                                        locale="default"
                                        id={"reserved_to_time"}
                                        dateFormat={t('YY-MM-DD')}
                                        showIcon
                                        showTime={dailyReservationOnly}
                                        timeOnly={dailyReservationOnly}
                                        hourFormat="24"
                                        stepMinute={30}
                                        onChange={(e) => {
                                          setReservedToTime(moment.utc(e.value).local().format('HH:mm'))
                                        }}/>
                            </div>
                            {getFormErrorMessage(meta)}
                          </>
                        ) : reservationFromToInputType === 'merged' ? (
                          <>
                            <Calendar
                              id={"reserved_from"}
                              value={reservedFromDate ? [
                                moment(reservedFromDate, 'YYYY-MM-DD').toDate(),
                                reservedToDate ? moment(reservedToDate, 'YYYY-MM-DD').toDate() : null
                              ] : null}
                              locale="default"
                              dateFormat={t('YY-MM-DD')}
                              showOtherMonths
                              selectOtherMonths
                              selectionMode="range"
                              showIcon
                              onChange={(e) => {
                                const nextReservedFromDate = e.value?.[0] ? moment.utc(e.value[0]).local().format(t('YYYY-MM-DD')) : null;
                                const nextReservedToDate = e.value?.[1] ? moment.utc(e.value[1]).local().format(t('YYYY-MM-DD')) : null;
                                setReservedFromDate(nextReservedFromDate)
                                setReservedToDate(nextReservedToDate)
                                setFormData((prevState) => ({
                                  ...prevState,
                                  reserved_from: nextReservedFromDate,
                                  reserved_to: nextReservedToDate
                                }))
                                input.onChange(nextReservedFromDate)
                              }}
                            />
                            {getFormErrorMessage(meta)}
                          </>
                        ) : (
                          <>
                            <div className={"p-inputgroup"}>
                              <Calendar
                                id={"reserved_from"}
                                value={reservedFromDate ? moment(reservedFromDate, 'YYYY-MM-DD').toDate() : null}
                                locale="default"
                                dateFormat={t('YY-MM-DD')}
                                showOtherMonths
                                selectOtherMonths
                                showIcon
                                onChange={(e) => {
                                  const nextReservedFromDate = e.value ? moment.utc(e.value).local().format(t('YYYY-MM-DD')) : null;
                                  setReservedFromDate(nextReservedFromDate)
                                  setFormData((prevState) => ({
                                    ...prevState,
                                    reserved_from: nextReservedFromDate
                                  }))
                                  input.onChange(nextReservedFromDate)
                                }}
                              />
                              <Calendar
                                id={"reserved_to"}
                                className={""}
                                value={reservedToDate ? moment(reservedToDate, 'YYYY-MM-DD').toDate() : null}
                                locale="default"
                                dateFormat={t('YY-MM-DD')}
                                showOtherMonths
                                selectOtherMonths
                                showIcon
                                onChange={(e) => {
                                  const nextReservedToDate = e.value ? moment.utc(e.value).local().format(t('YYYY-MM-DD')) : null;
                                  setReservedToDate(nextReservedToDate)
                                  setFormData((prevState) => ({
                                    ...prevState,
                                    reserved_to: nextReservedToDate
                                  }))
                                }}
                              />
                            </div>
                            {getFormErrorMessage(meta)}
                          </>
                        )}
                      </>
                    ) : (
                      <Calendar
                        disabled
                        selectionMode="range"
                        showIcon
                        locale="default"
                        dateFormat={t('YY-MM-DD')}
                        showOtherMonths
                        selectOtherMonths
                        value={null}
                      />
                    )}
                        </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-6"}>
              <Field name="channel" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <HelpComponent type={"field"} field={"channel"}/>
                  <label htmlFor="channel"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{t('channel')}</label>
                  <span className="">
                          <Dropdown options={chanel}
                                    optionLabel="name"
                                    optionValue="id"
                                    id={"channel"}
                                    emptyMessage={t('empty_message')}
                                    onChange={(e) => {
                                      setFormData({
                                        ...formData,
                                        channel: e.value,
                                      })
                                    }}
                                    value={formData?.channel?.id || formData.channel}
                                    showClear
                          />
                        </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-6"}>
              <Field name="price_category" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <HelpComponent type={"field"} field={"price_category"}/>
                  <label htmlFor="price_category"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{t('pricecategory')}</label>
                  <span className="">
                          <Dropdown options={priceCategories}
                                    optionLabel="name"
                                    optionValue="id"
                                    id={"price_category"}
                                    emptyMessage={t('empty_message')}
                                    onChange={(e) => {
                                      setFormData({
                                        ...formData,
                                        price_category: e.value,
                                      })
                                    }}
                                    disabled={!formData?.residential_unit}
                                    value={formData?.price_category?.id || formData.price_category}
                                    showClear
                          />
                        </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-12 p-xl-12"}>
              <Field name="note" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <HelpComponent type={"field"} field={"note"}/>
                  <label htmlFor="note"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{t('note')}</label>
                  <span className="p-d-block">
                      <InputText id="note" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     note: e.target.value
                                   })
                                 }}
                                 value={formData.note}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-6"}>
              <Field name="guest_information_request_page" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <HelpComponent type={"field"} field={"guest_information_request_page"}/>
                  <label htmlFor="guest_information_request_page"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{t('guest_information_request_page')}</label>
                  <span className="p-inputgroup">
                        <Dropdown options={guestInfos}
                                  optionLabel="name"
                                  optionValue="id"
                                  id={"guest_information_request_page"}
                                  emptyMessage={t('empty_message')}
                                  onChange={(e) => {
                                    setFormData({
                                      ...formData,
                                      guest_information_request_page: e.value
                                    })
                                  }}
                                  value={formData?.guest_information_request_page?.id || formData?.guest_information_request_page}
                                  showClear
                        />
                      </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-6"}>
              <Field name="number_of_guests" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <HelpComponent type={"field"} field={"number_of_guests"}/>
                  <label htmlFor="number_of_guests"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{t('number_of_guests')}</label>
                  <span className="p-d-block">
                            <InputText id="number_of_guests" {...input}
                                       keyfilter={"num"}
                                       onChange={(e) => {
                                         setFormData({
                                           ...formData,
                                           number_of_guests: e.target.value
                                         })
                                       }}
                                       value={formData.number_of_guests}
                                       className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                          </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-6"}>
              <Field name="status" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <HelpComponent type={"field"} field={"status"}/>
                  <label htmlFor="status"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{t('status')}</label>
                  <span className="p-d-block">
                          <SplitButton
                            label={t((formData.status === 'confirmed' ? 'reserved' : formData.status) || 'no_status')}
                            id="buttonStatus"
                            onShow={() => {
                              setPossibleStatuses([
                                {
                                  label: t('pending'),
                                  value: "pending",
                                  command: () => {
                                    setFormData({
                                      ...formData,
                                      status: "pending"
                                    })
                                  }
                                },
                                {
                                  label: t('reserved'),
                                  value: "confirmed",
                                  command: () => {
                                    setFormData({
                                      ...formData,
                                      status: "confirmed"
                                    })
                                  }
                                },
                              ])
                            }}
                            onClick={() => {
                              document.getElementById('buttonStatus').getElementsByClassName('p-splitbutton-menubutton')[0].click()
                            }}
                            className={
                              formData.status === 'cancelled'
                                ? 'p-button-danger'
                                : formData.status === 'pending'
                                  ? 'p-button-secondary'
                                  : ['no_show', undefined].includes(formData.status) || (!formData.id && formData.status === 'confirmed')
                                  ? 'p-button-warning'
                                  : ['confirmed', 'checked_in', 'checked_out'].includes(formData.status)
                                    ? 'p-button-success'
                                    : 'p-button-secondary'
                            }
                            model={possibleStatuses}/>
                          </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
          </div>
          <div className={"p-grid p-mt-2"}>
            <div className={"p-col-12 p-text-right"}>
              {/*<Button type="button" className="p-button-secondary" icon={"pi pi-ban"}*/}
              {/*        loading={loading}*/}
              {/*        label={t('set_ooo')}*/}
              {/*        onClick={() => {*/}
              {/*          if (window.App.state.propsReservation && window.App.state.propsReservation.resource && window.App.state.propsReservation.resource.toString().includes('B-')) {*/}
              {/*            navigate('/calendar/out-of-order/create-berth')*/}
              {/*            window.App.setState({*/}
              {/*              //sidebarOooberthForm: true,*/}
              {/*              selectedBerthId: Number(window.App.state.propsReservation.resource.toString().replace('B-', '')),*/}
              {/*            })*/}
              {/*          }*/}
              {/*          if (window.App.state.propsReservation && window.App.state.propsReservation.resource && window.App.state.propsReservation.resource.toString().includes('U-')) {*/}
              {/*            navigate('/calendar/out-of-order/create-unit')*/}
              {/*            window.App.setState({*/}
              {/*              //sidebarOoounitForm: true,*/}
              {/*              selectedUnitId: Number(window.App.state.propsReservation.resource.toString().replace('U-', '')),*/}
              {/*            })*/}
              {/*          }*/}
              {/*        }}/>*/}
              {formData && formData.id && !formData.relocated_to && relocated === true &&
                <Button type="button" className="p-button-warning" icon={"pi pi-sign-in"}
                        loading={loading}
                        label={t('relocate')}
                        onClick={() => {
                          setLoading(true)
                          apiCall('post', 'reservation/' + formData.id + '/relocate', formData)
                            .then(response => {
                              setLoading(false)
                              window.App.toastShow('success', t('success'), response.data.message)
                              window.App.setState({
                                rerenderReservationList: true,
                              })
                            })
                            .catch(error => {
                              setLoading(false)
                              window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
                            })
                        }}/>
              }
            </div>
          </div>
        </Panel>
        <Panel className={"p-mt-3"}>
          <h3 className={"p-mt-0"}>
            {t('contact')}
          </h3>
          <HelpComponent type={"section"} tabNumber={0} sectionNumber={2}/>
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-6"}>
              <Field name="contact_name" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <HelpComponent type={"field"} field={"contact_name"}/>
                  <label htmlFor="contact_name"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{t('contact_name')}</label>
                  <span className="p-d-block">
                            <InputText id="contact_name" {...input}
                                       onChange={(e) => {
                                         setFormData({
                                           ...formData,
                                           contact_name: e.target.value
                                         })
                                       }}
                                       value={formData.contact_name}
                                       className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                          </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-6"}>
              <Field name="contact_email" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <HelpComponent type={"field"} field={"contact_email"}/>
                  <label htmlFor="contact_email"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{t('contact_email')}</label>
                  <span className="p-d-block">
                            <InputText id="contact_email" {...input}
                                       onChange={(e) => {
                                         setFormData({
                                           ...formData,
                                           contact_email: e.target.value
                                         })
                                       }}
                                       value={formData.contact_email}
                                       className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                          </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-6"}>
              <Field name="contact_number" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <HelpComponent type={"field"} field={"contact_number"}/>
                  <label htmlFor="contact_number"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{t('contact_phone')}</label>
                  <span className="p-d-block">
                            <InputText id="contact_number" {...input}
                                       onChange={(e) => {
                                         setFormData({
                                           ...formData,
                                           contact_number: e.target.value
                                         })
                                       }}
                                       value={formData.contact_number}
                                       className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                          </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
          </div>
        </Panel>
        {formData.errors && formData.errors[0] &&
          <_FM_ReservationErrorsListComponent errors={formData.errors}/>
        }
      </form>
    )}/>
  )
}
export default withTranslation('common')(_FM_ReservationResourceFormComponent);
